import { BaseRouteService } from 'core/services';

class ShipmentCostRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'shipment-cost/';
	}

	findTn(filter) {
		return super.create(this.base + 'search-tn', filter);
	}

	findCharge(filter) {
		return super.create(this.base + 'search-charge', filter);
	}

	uploadBillData(isOverride, sourceOfChange) {
		return super.create(this.base + 'upload-bill/?isOverride={isOverride}&sourceOfChange={sourceOfChange}', {
			isOverride,
			sourceOfChange,
		});
	}

	checkTrackingNumbers() {
		return super.create(this.base + 'check-tracking-numbers');
	}

	exportToCsv(filter) {
		return super.create(this.base + 'export', filter);
	}

	deleteInvoice(invoiceNumber) {
		return this.uriTemplateService.parse(this.base + 'delete-invoice/{invoiceNumber}').expand({ invoiceNumber });
	}
}

export default ShipmentCostRouteService;
